import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PricingInfo {
  slug: string;
  screenshotUrl: string;
  version: string;
  pricingInfo: any;
}

interface PricingHistoryState {
  history: Record<string, PricingInfo[]>;
  loading: boolean;
  error: string | null;
}

const initialState: PricingHistoryState = {
  history: {},
  loading: true,
  error: null,
};

const pricingHistorySlice = createSlice({
  name: 'pricingHistory',
  initialState,
  reducers: {
    setPricingHistory: (state, action: PayloadAction<Record<string, PricingInfo[]>>) => {
      state.history = action.payload;
      state.loading = false;
    },
    setPricingHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPricingHistoryError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setPricingHistory, setPricingHistoryLoading, setPricingHistoryError } = pricingHistorySlice.actions;
export default pricingHistorySlice.reducer;